module.exports = __webpack_public_path__ + "img/6.2827e521.png";